
import { config } from "dotenv";

config();

export const isProd = process.env.REACT_APP_ENV?.toLowerCase?.()?.startsWith?.('prod');

export const mainServerURL = process.env.REACT_APP_MAIN_SERVER_URL;
export const userServerURL = process.env.REACT_APP_USER_SERVER_URL;
